angular.module( 'acme.view.application.sherpa.activities.tenant', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.sherpa.activities.tenant.controllers',
  'acme.view.application.sherpa.activities.b2b.controllers',
  'acme.view.application.sherpa.activities.b2c.controllers',
  'acme.common.directive.dataGrid'

])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var sherpaActivitiesTenant = {
        name: 'application.sherpa.activities.tenant',
        url: '/tenant?tenantId&list',
        views: {
          "subview-main": {
            controller: 'SherpaActivitiesTenantController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/sherpa/activities/tenant/tenantList.tpl.html'
          }
        },
        data: {
          pageTitle: 'CSR Activities'
        }
      };

    $stateProvider
      .state(sherpaActivitiesTenant);
});
